import React from 'react';
import { Navigate } from 'react-router-dom';
import {
	Alert,
	AlertDescription,
	AlertIcon,
	Box,
	Flex,
	Spinner,
} from '@chakra-ui/react';
import { useAuthenticatedUserInfo } from '../../../services/Contexts/AuthenticatedUserInfoContext';

/**
 * Renders a feature page only when its access query says `{ enabled: true }` and `isAllowed`
 * (e.g. a user permission) holds. Everyone else is sent to /unauthorized, so typing the URL
 * doesn't help.
 */
const PlatformFeatureGate = ({ access, isAllowed = true, children }) => {
	const { companyId } = useAuthenticatedUserInfo();

	// companyId, role and permissions arrive together, so wait for them before judging access.
	if (companyId && !isAllowed) return <Navigate to='/unauthorized' replace />;

	if (!companyId || access.isLoading) {
		return (
			<Flex justify='center' align='center' minH='60vh'>
				<Spinner size='xl' color='teal.500' thickness='4px' />
			</Flex>
		);
	}

	if (access.error) {
		return (
			<Box px={{ base: 4, md: 8 }} py={6}>
				<Alert status='error' borderRadius='xl'>
					<AlertIcon />
					<AlertDescription>{access.error.message}</AlertDescription>
				</Alert>
			</Box>
		);
	}

	if (!access.data?.enabled) return <Navigate to='/unauthorized' replace />;

	return children;
};

export default PlatformFeatureGate;
